// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { _throwInternal, dateTimeUtilsDuration } from "@microsoft/applicationinsights-core-js";
/**
 * Factory function to create a Timing instance.
 * @param logger - Diagnostic logger
 * @param name - Name identifier for timing operations
 * @returns A new ITiming instance.
 * @internal
 */
export function createTiming(logger, name) {
    var _events = {};
    var timing = {
        action: null,
        start: function (name) {
            if (typeof _events[name] !== "undefined") {
                _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 62 /* _eInternalMessageId.StartCalledMoreThanOnce */, "start was called more than once for this event without calling stop.", { name: name, key: name }, true);
            }
            _events[name] = +new Date;
        },
        stop: function (name, url, properties, measurements) {
            var start = _events[name];
            if (isNaN(start)) {
                _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 63 /* _eInternalMessageId.StopCalledWithoutStart */, "stop was called without a corresponding start.", { name: name, key: name }, true);
            }
            else {
                var end = +new Date;
                var duration = dateTimeUtilsDuration(start, end);
                timing.action(name, url, duration, properties, measurements);
            }
            delete _events[name];
            _events[name] = undefined;
        }
    };
    return timing;
}
//# sourceMappingURL=Timing.js.map